module.exports = __webpack_public_path__ + "img/rnd-blue.88a9141f.png";